import { Card } from 'react-bootstrap';
import styles from './resources.module.css';

export const BlogCard = ({ coverImg, title, date }) => {
  return (
    <Card className={`border-0 shadow-sm mb-4 ${styles.card}`}>
      <Card.Img
        variant="top"
        src={coverImg}
        alt={title}
        className={`${styles.hoverZoom} ${styles.coverImg}`}
      />
      <Card.Body className="px-2 pb-3 pt-2">
        <h6 className={styles.cardTitle} title={title}>{title}</h6>
        <span className="text-13 text-muted">{date}</span>
      </Card.Body>
    </Card>
  );
};
